import { Badge, Box, Button, Dialog, Grid, IconButton, Popover, TextField, Tooltip, Typography } from '@mui/material';
import { WorkOrderStatusButtons } from './status-buttons.component';
import { useEffect, useState } from 'react';
import { ScheduleDialog } from './shedule.dialog';
import { Icons } from '../../../assets/icons';
import { minWidth } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import { PurchaseOrderDialog } from './puchase-order.dialog';
import { useFileDownload } from '../../../components/file-download';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { Link, useNavigate } from 'react-router-dom';
import { FileDownloadDialog } from './file-download.dialog';
import { ContactsListDialog } from '../../contacts/contacts-list.dialog';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { useSaveData } from '../../../hooks/useSaveData';
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { ContactsDialogWithGridSelect } from '../../contacts/contact-diallog-with-grid-selection';
import { contactApiKeyStore } from '../../../api/contact-api-key-store';
import { Contact } from '../../../models/contact';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';
import CloseIcon from '@mui/icons-material/Close';
import WorkOrderEmployeeGrid from '../work-order-employee-grid/work-order-employee-grid';
import WorkOrderEmployee from '../work-order-employee-grid/work-order-employee';
import { NotesDialog } from '../../note/notes.dialog';
import { ScheduleDuxCallDialog } from './schedule-dux-call/schedule-dux-call.dialog';

const styling = {
  labelStyle: {
    color: '  rgb(163 161 161)',
    fontSize: '14px',
    fontWeight: '600',
  },
  secondaryLabelStyle: {
    color: 'rgb(163 161 161)',
    fontSize: '14px',
    fontWeight: '600',
    paddingRight: '5px'
  },
  valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
};

interface HeaderValueCellProps {
  workOrder?: any;
  heading: string;
  value: any;
  valueID?: any;
  isRequired?: boolean;
  hasPurchaseOrders?: boolean;
  fileType?: string;
  className?: string;
  reloadData?: any;
  handleOpenPurchaseOrderDialog?: () => void;
  handleDownloadClick?: () => void;
  isCompleted?: boolean;
  canEditPO?: boolean;
  refetchUnit?: () => void;
  setIsLoadingRules?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface WorkorderItemProps {
  item: any;
  reloadData: any;
  isCompleted?: boolean;
  refetchUnit?: () => void;
}

const HeaderValueCell = ({ heading, value, valueID, className }: HeaderValueCellProps) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const handleClickJobsite = () => {
    // navigate(`/units?searchType=jobsites&searchText=${value}`);
    window.open(`/units/profile/${valueID}`, '_blank');
  };
  return (
    <Grid container spacing={0.5} className={className}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
          {heading}
        </Typography>
        {heading == 'Jobsite' ? (
          value ? (
            <div style={{ cursor: 'pointer' }} onClick={handleClickJobsite}>
              <Typography
                component="span"
                style={{
                  color: isHovered ? '#0000b5' : '#0000b5',
                  textDecoration: isHovered ? 'underline' : 'none',
                  cursor: 'pointer',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {value}
              </Typography>
            </div>
          ) : (
            <Typography variant="body1" className="custDesign">
              {'-'}
            </Typography>
          )
        ) : (
          <Typography variant="body1" className="custDesign">
            {value ? value : '-'}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

const HeaderDollarCell = ({ value, className }: HeaderValueCellProps) => {
  return (
    <Grid
      container
      spacing={0.5}
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'row',
        minWidth: '125px',
        paddingRight: '0',
        justifyContent: 'end',
        alignItems: 'center',
      }}
    >
      <Typography variant="body1" color="textPrimary" className="labelPrice" style={styling.labelStyle}>
        <img src={Icons.Dollar} alt="$" />
      </Typography>
      <Typography variant="body1" className="txtPrice rP0">
        {value ? value : '-'}
      </Typography>
    </Grid>
  );
};

const InspectorData = ({
  workOrder,
  heading,
  value,
  className,
  reloadData,
  setIsLoadingRules,
  isCompleted,
  refetchUnit
}: HeaderValueCellProps) => {
  const [openSchedule, setOpenSchedule] = useState(false);
  const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogRule, setOpenDialogRule] = useState(false);
  const [scheduleRule, setScheduleDialogRule] = useState([]);
  const [pendingWorkOrder, setPendingWorkOrder] = useState([]);
  const [openFFDispatchDialog, setOpenFFDispatchDialog] = useState(false);
  const [currentWorkOrderID, setCurrentWorkOrderID] = useState(0);

  const { isLoading: sheduleRuleLoading, mutateAsync: sheduleRuleCheck } = useSaveData<any>(
    workOrdersApiKeyStore.checkWorkOrderSheduleRules()
    //workOrdersApiKeyStore.generateWorkOrderSheduleRules()
  );

  // const { isLoading: checkSheduleRuleLoading, mutateAsync: checkSheduleRuleCheck } = useSaveData<any>(
  //   workOrdersApiKeyStore.checkWorkOrderSheduleRules()
  // );

  const handleScheduleClick = async (
    id: any, //showAirflowWarning: any,
    ffDispatchID: any,
    status: any
  ) => {
    // if (showAirflowWarning) {
    //   setCurrentWorkOrderID(id);

    //   handleOpenDialog();
    // } else {
    //   const result = await sheduleRuleCheck({ data: { workOrderID: id } });
    //   setOpenSchedule(true);
    // }

    await sheduleRuleCheck({ data: { workOrderID: id } }).then((data) => {
      if (data?.data?.pendingRules?.length > 0) {
        setScheduleDialogRule(data?.data?.pendingRules || []);
        setPendingWorkOrder(data?.data?.preReqWorkOrders || []);
        setOpenDialogRule(true);
      } else {
        setOpenSchedule(true);
      }
    });
  };

  useEffect(() => {
    setIsLoadingRules?.(sheduleRuleLoading);
  }, [sheduleRuleLoading]);

  const handleScheduleClose = () => {
    setOpenSchedule(false);
  };

  const handleSaveComplete = () => {
    reloadData?.();
    if (workOrder?.serviceName === "PPI: Certificate of Compliance")
      refetchUnit?.();

  };

  const closeDialogAlert = () => {
    setIsConfirmation(false);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };
  const closeDialogRule = () => {
    setScheduleDialogRule([]);
    setPendingWorkOrder([]);
    setOpenDialogRule(false);
  };
  const closeFFDispatchDialog = () => {
    setOpenFFDispatchDialog(false);
  };
  const handleSumbitConfirm = async () => {
    const result = await sheduleRuleCheck({ data: { workOrderID: currentWorkOrderID } });
    closeDialog();
    setOpenSchedule(true);
  };
  const handleSumbitRuleConfirm = async () => {
    setScheduleDialogRule([]);
    setPendingWorkOrder([]);
    setOpenDialogRule(false);
    setOpenSchedule(true);
  };
  const handleSumbitConfirmFFDispatch = async () => {
    const result = await sheduleRuleCheck({ data: { workOrderID: currentWorkOrderID } });
    closeFFDispatchDialog();
    setOpenSchedule(true);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container spacing={0.5} className={className}>
      <div
        //  onClick={
        //   workOrder.canSchedule
        //     ? (workOrder?.workOrderStatus === 'Scheduled' && !workOrder.ffDispatchID && workOrder.isFastFieldRetest && workOrder.fastFieldFormID!==0)
        //       ? () => {}
        //       : () => handleScheduleClick(workOrder?.workOrderID, workOrder?.showAirflowWarning,workOrder?.ffDispatchID,workOrder?.workOrderStatus)
        //     : () => {}
        //   }
        onClick={
          workOrder.canSchedule
            ? () =>
              handleScheduleClick(
                workOrder?.workOrderID,
                // workOrder?.showAirflowWarning,
                workOrder?.ffDispatchID,
                workOrder?.workOrderStatus
              )
            : () => { }
        }
        style={{
          cursor: workOrder.canSchedule ? 'pointer' : ' default',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '4px',
        }}
      >
        <Grid item lg={12} sm={12} xl={12} xs={12} className="d-flex">
          <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
            {heading}
          </Typography>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            {workOrder.canSchedule && (
              <GuardedComponent requiredPermissions={[UserPermissionName.SCHEDULE_WORKORDER]}>
                <Button
                  disabled={!!isCompleted}
                  style={{
                    marginLeft: 'auto',
                    padding: '0',
                    minWidth: 'auto',
                    marginRight: '10px',
                    marginTop: '5px',
                  }}
                >
                  <Tooltip
                    title={
                      // <Typography variant="body1">{!workOrder?.scheduledDate ? 'Schedule' : (workOrder?.workOrderStatus === "Scheduled" && !workOrder.ffDispatchID) ?'This work order has not been dispatched to Fastfield yet.' : 'Reschedule'}</Typography>
                      <Typography variant="body1">{!workOrder?.scheduledDate ? 'Schedule' : 'Reschedule'}</Typography>
                    }
                  >
                    <img src={Icons.scheduleCalendar} alt="Schedule" />
                  </Tooltip>
                </Button>
              </GuardedComponent>
            )}
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12} style={{ minHeight: '24px' }}>
          <Typography variant="body1" color="text.secondary" style={styling.valueStyle}>
            {value ? value : '-'}
          </Typography>
        </Grid>
        {workOrder?.remoteInspection && (
          <Grid item lg={12} sm={12} xl={12} xs={12}>

            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Typography variant="body1" color="textPrimary" style={styling.secondaryLabelStyle}>
                Secondary Inspector
              </Typography>
              <Typography variant="body1" color="text.secondary" style={styling.valueStyle}>
                {workOrder?.secondaryInspectorName ? workOrder?.secondaryInspectorName : '-'}
              </Typography>
            </Grid>
          </Grid>
        )}
      </div>
      {openSchedule && (
        <ScheduleDialog workOrder={workOrder} onClose={handleScheduleClose} onSaveCompleted={handleSaveComplete} />
      )}
      {isConfirmation && (
        <Dialog
          open={isConfirmation}
          className="modalpopup"
          title={'Alert'}
        // onClose={closeDialogAlert}
        >
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>You can not schedule the inspection without a purchase order.</div>
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <div></div>
              <button
                className="btn btn-sm btn-primary  btn-delete"
                type="button"
                onClick={() => setIsConfirmation(false)}
                style={{ cursor: 'pointer' }}
              >
                Ok
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      <>
        {openDialog && (
          <Dialog
            open={openDialog}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          // onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  {ishavePermission
                    ? 'The airflow value is not greater than zero. Are you sure you want to continue?'
                    : 'The airflow value is not greater than zero. You do not have permission to schedule.'}
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeDialog}
                  autoFocus
                >
                  Cancel
                </button>
                {ishavePermission && (
                  <button
                    className="btn btn-sm btn-primary  btn-delete"
                    style={{
                      backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                      color: isReadOnlyPermission ? 'black' : '#fff',
                      cursor: 'pointer'
                    }}
                    type="button"
                    onClick={handleSumbitConfirm}
                    disabled={sheduleRuleLoading || isReadOnlyPermission}
                  >
                    Confirm
                  </button>
                )}
              </div>
            </DialogActionsBar>
          </Dialog>
        )}

        {openDialogRule && (
          <Dialog
            open={openDialogRule}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          // onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  <h4>Please see the below validations</h4>
                  <br></br>
                  <ul>{scheduleRule?.map((data: any) => <li key={data}>{data}</li>)}
                    {pendingWorkOrder?.length > 0 && (
                      <dl>
                        <dt>Pending Work Orders:</dt>
                        {pendingWorkOrder?.map((data: any) => <dd key={data}>- {data}</dd>)}
                      </dl>
                    )}
                  </ul>
                </div>
                <br></br>
                <div>
                  {ishavePermission ? (
                    <h5>
                      You have the permission to schedule without completing the validations. Are you sure you want to
                      continue?
                    </h5>
                  ) : (
                    <h5>You can not schedule without completing the validations.</h5>
                  )}
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeDialogRule}
                  autoFocus
                >
                  Cancel
                </button>
                {ishavePermission && (
                  <button
                    className="btn btn-sm btn-primary  btn-delete"
                    style={{
                      backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                      color: isReadOnlyPermission ? 'black' : '#fff',
                      cursor: 'pointer'
                    }}
                    type="button"
                    onClick={handleSumbitRuleConfirm}
                    disabled={sheduleRuleLoading || isReadOnlyPermission}
                  >
                    Confirm
                  </button>
                )}
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </>

      <>
        {openFFDispatchDialog && (
          <Dialog
            open={openFFDispatchDialog}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          // onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  This work order is waiting for Fastfield results. Please cross-check the work order status from the
                  Fastfield before reschedule. Do you want to continue? This work order is waiting for Fastfield
                  results. Please cross-check the work order status from the Fastfield before reschedule. Do you want to
                  continue?
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeFFDispatchDialog}
                  autoFocus
                >
                  Cancel
                </button>

                <button
                  className="btn btn-sm btn-primary  btn-delete"
                  style={{
                    backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                    color: isReadOnlyPermission ? 'black' : '#fff',
                    cursor: 'pointer'
                  }}
                  type="button"
                  onClick={handleSumbitConfirmFFDispatch}
                  disabled={sheduleRuleLoading || isReadOnlyPermission}
                >
                  Confirm
                </button>
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </>
    </Grid>
  );
};

const PurchaseOrderData = ({
  heading,
  value,
  isRequired,
  hasPurchaseOrders,
  fileType,
  className,
  handleOpenPurchaseOrderDialog,
  handleDownloadClick,
  isCompleted,
  canEditPO
}: HeaderValueCellProps) => {
  return (
    <Grid container spacing={0.5} className={className}>
      <div className="bgWhite">
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Typography
            variant="body1"
            color="textPrimary"
            style={{
              color: '#000',
              fontWeight: '500',
              fontSize: '13px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
            className="d-flex flex-row"
          >
            <div className="d-flex flex-column">
              <span>Purchase Order</span>
              <div className="d-flex" style={{ alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}> {!isRequired ? ' ( Not Required )' : ' ( Required )'} </span>
                {hasPurchaseOrders && (
                  <Tooltip title={<Typography variant="body1">Purchase Order Added</Typography>}>
                    <img src={Icons.IconCheckFillGreen} />
                  </Tooltip>
                )}
              </div>
            </div>
            {canEditPO && (
              <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PO_WORKORDER]}>
                <Button
                  disabled={!!isCompleted}
                  style={{ color: !isCompleted ? '' : 'white' }}
                  className="btn btn-xs btn-primary"
                  onClick={handleOpenPurchaseOrderDialog}
                >
                  <span>{/* {heading} */} View/ Upload PO</span>{' '}
                </Button>
              </GuardedComponent>
            )}
          </Typography>
        </Grid>
        {/* <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Typography
            variant="body1"
            color="text.secondary"
            style={{ color: '#000', fontWeight: '500', fontSize: '13px', alignItems: 'center' }}
            className="d-flex"
          >
            <span>{value ? value : 'N/A'}</span>{' '}
            <Button onClick={handleDownloadClick}>
              <Tooltip title={<Typography variant="body1">Download Purchase Order</Typography>}>
                {!fileType ? (
                  <img src={Icons.poDownload} alt="Download Purchase Order" />
                ) : (
                  <img src={Icons.FileDownload} alt="Download Purchase Order" />
                )}
              </Tooltip>
            </Button>
          </Typography>
        </Grid> */}
      </div>
    </Grid>
  );
};

export const WorkorderItem = ({ item, reloadData, isCompleted, refetchUnit }: WorkorderItemProps) => {
  const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [isOpenFeeWave, setIsOpenFeeWave] = useState(false);
  const [isOpenEmployeeGrid, setIsOpenEmployeeGrid] = useState(false);
  const [openFileDialog, setOpenFileDialog] = useState<boolean>(false);
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [openPurchaseOrder, setOpenPurchaseOrder] = useState(false);
  const [workedHoursValue, setWorkedHoursValue] = useState<string>('');
  const [isEditEorkedHours, setIsEditWorkedHours] = useState<boolean>(false);
  const [reasonError, setReasonError] = useState<boolean>(false);
  const [isLoadingRules, setIsLoadingRules] = useState<boolean>(false);
  const [openScheduleDuxDialog, setOpenScheduleDuxDialog] = useState<any>();
  const [valueForTab, setValueForTab] = useState('view');
  const [editItem, setEditItem] = useState<Contact>();
  const form = useReactHookForm({});
  const { isLoading: isLoadingWorkOrder, mutateAsync } = useSaveData(workOrdersApiKeyStore.updateWorkOrderHours());
  const navigate = useNavigate();
  const { error, downloadFile, isLoading } = useFileDownload();

  const handleOpenPurchaseOrderDialog = () => {
    setOpenPurchaseOrder(true);
  };
  const handleClosePurchaseOrderDialog = () => {
    setOpenPurchaseOrder(false);
  };

  const handleOpenNotesDialog = () => {
    setOpenNoteDialog(true);
  };
  const handleCloseNotesDialog = () => {
    setOpenNoteDialog(false);
  };

  const handleDownloadClick = () => {
    const data = { ...item, workOrderID: item?.workOrderID, fileType: item?.fileType };
    downloadFile({ additionalData: data });
  };

  const handleWorkedHoursValueChange = (e: any) => {
    setReasonError(false);
    const value = e.target.value;
    // Regular expression to match a number with up to 2 decimal places
    const regex = /^\d*\.?\d{0,2}$/;

    // If the value matches the regex, update the state
    if (regex.test(value)) {
      setWorkedHoursValue(value);
    }
    // setWorkedHoursValue(e.target.value);
  };

  const handleWorkedHoursEditClick = (value: any) => {
    setIsEditWorkedHours(true);
    setWorkedHoursValue(value);
  };

  const handleSaveClick = async () => {
    const updatedWorkedHours = workedHoursValue?.toString() || '';
    if (!updatedWorkedHours.trim()) {
      setReasonError(true);
      return;
    }
    await mutateAsync({
      data: { workOrderID: item?.workOrderID, workedHours: workedHoursValue },
    });
    reloadData();
    setIsEditWorkedHours(false);
  };

  const handleCloseAddContactForm = (contacts: Contact[]) => {
    setIsContactVisible(false);
  };

  const handleSubmit = async (value: any): Promise<any> => { };

  const handleCloseEmployeeGrid = () => {
    setIsOpenEmployeeGrid(false);
  };

  const handleSendDuxCallSuccess = () => {
    reloadData?.();
    setOpenScheduleDuxDialog(undefined);
  }

  const handleClosedScheduleCallDialog = () => {
    setOpenScheduleDuxDialog(undefined);
  }

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box className="subHead2 woWrap">
        <LoadingIndicator isLoading={isLoading || isLoadingRules} />
        <Grid container spacing={2}>
          <Grid item lg={3} className="woLeftSection flex-column">
            <div className="d-flex flex-row" style={{ flex: '1', flexDirection: 'column', paddingBottom: '0' }}>
              <HeaderValueCell className="woNumb" heading="Work Order" value={item?.workOrderNumber} />

              <div
                style={{
                  display: 'flex',
                  flex: '1',
                  justifyContent: 'center',
                  alignItems: 'start',
                  paddingTop: '10px',
                }}
              > {item?.canEditContactFileNote && (
                <div style={{ display: 'flex', flex: '1' }}>

                  <Button
                    disabled={!!isCompleted}
                    style={{ padding: '0', minWidth: 'auto', marginRight: '20px' }}
                    onClick={() => {
                      setIsContactVisible(true);
                      setValueForTab('view');
                    }}
                  >
                    <Tooltip title={<Typography variant="body1">View/ Add Contacts</Typography>}>
                      <img src={Icons.Contacts} />
                    </Tooltip>
                  </Button>
                  <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
                    <Button
                      onClick={handleOpenNotesDialog}
                      style={{ padding: '0', minWidth: 'auto', marginRight: '10px' }}
                      disabled={!!isCompleted}
                    >
                      <Tooltip title={<Typography variant="body1">Note</Typography>}>
                        <img src={Icons.Notes} />
                      </Tooltip>
                    </Button>
                  </GuardedComponent>

                </div>)}
                <HeaderDollarCell heading="$" value={item?.price} className="txtRight singleLine " />
              </div>
            </div>
            {/* {item?.inspectionRequestedFrom === 'Dux' && isDUXEnabled && ( */}
            {item?.inspectionRequestTypeText !== '' && isDUXEnabled && (
              <div
                className="d-flex"
                style={{
                  alignItems: 'flex-start',
                  // display: 'none',
                }}
              >
                <Badge className="statusBadge statusBadge-warning">
                  {' '}
                  {/* <img src={Icons.IconCheckFillGreen} /> Inspection Request Received */}
                  <img src={Icons.IconCheckFillGreen} /> {item?.inspectionRequestTypeText}
                </Badge>
              </div>
            )}
            <div className="d-flex flex-column" style={{ flex: '1', paddingTop: '0' }}>
              <HeaderValueCell className="serviceNam" heading="Service" value={item?.serviceName} />
            </div>
            <div className="d-flex flex-column" style={{ flex: '1', paddingTop: '0' }}>
              <HeaderValueCell heading="Municipality Code" value={item?.municipality} />
            </div>
            <div className="d-flex flex-column" style={{ flex: '1', paddingTop: '0' }}>
              <InspectorData
                className="bgWhite"
                heading="Inspector"
                value={item?.inspectorName}
                workOrder={item}
                reloadData={reloadData}
                setIsLoadingRules={setIsLoadingRules}
                isCompleted={isCompleted}
                refetchUnit={refetchUnit}
              />
              {!!item?.isMigratedData && (
                <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                  Migrated Data
                </Typography>
              )}
            </div>

            <div style={{ display: 'flex', flex: '1' }}>
              <PurchaseOrderData
                heading="Purchase Order"
                value={item?.purchaseOrderNo}
                isRequired={item?.requirePurchaseOrder}
                isCompleted={isCompleted}
                canEditPO={item?.canEditPO}
                hasPurchaseOrders={item?.hasPurchaseOrders}
                fileType={item?.fileType}
                handleOpenPurchaseOrderDialog={handleOpenPurchaseOrderDialog}
                handleDownloadClick={handleDownloadClick}
              />{' '}
            </div>
          </Grid>
          <Grid item lg={9} className="woRightSection">
            <div className="d-flex" style={{ padding: '10px 10px 10px 0', gap: '10px', opacity: `${!item.isActive && '0.5'}` }}>
              <div style={{ display: 'flex', flex: '1' }}>
                <HeaderValueCell className="bgWhite" heading="Status" value={item?.workOrderStatus} />
              </div>
              <div className="d-flex" style={{ display: 'flex', flex: '3' }}>
                {/* <HeaderValueCell
                  className="bgWhite flex-column-dateFields"
                  heading="Forecasted Date"
                  value={item?.forecastedDate}
                /> */}
                {item.inspectionCodeResult !== null && item.inspectionCodeResult !== '' && (
                  <HeaderValueCell
                    className="bgWhite  flex-column-dateFields"
                    heading="PPI Status"
                    value={item?.inspectionCodeResult}
                  />
                )}
                {item.workOrderStatus !== 'Ready' && (
                  <HeaderValueCell
                    className="bgWhite  flex-column-dateFields"
                    heading="Scheduled Date"
                    value={item?.scheduledDate}
                  />
                )}
                {item.workOrderStatus !== 'Ready' && (
                  <HeaderValueCell
                    className="bgWhite"
                    heading="Scheduled Time"
                    value={`${item?.scheduledMeridiem ?? ''} ${item?.scheduledTime ?? ''}`}
                  />
                )}
                {item.workOrderStatus === 'Ready' && (
                  <HeaderValueCell
                    className="bgWhite  flex-column-dateFields"
                    heading="Proposed Schedule Date"
                    value={item?.proposedScheduledDate}
                  />
                )}
                <HeaderValueCell
                  className="bgWhite  flex-column-dateFields"
                  heading="Completed Date"
                  value={item?.completedOn}
                />
                <HeaderValueCell
                  className="bgWhite  flex-column-dateFields"
                  heading="Inspection Completed Date"
                  value={item?.ffInspectionCompletedOn}
                />
                <HeaderValueCell
                  className="bgWhite  flex-column-dateFields"
                  heading="Permit Number"
                  value={item?.permitNumber}
                />
                {/* <HeaderValueCell
                  className="bgWhite  flex-column-dateFields"
                  heading="Delivered Date"
                  value={item?.deliveredDate}
                /> */}
              </div>
              <div style={{ display: 'flex', flex: '1' }}>
                <HeaderValueCell className="bgWhite" heading="Cut-off Time" value={item?.cutOffTime} />
              </div>
            </div>
            <div className="d-flex  flex-column" style={{ padding: '0px 10px 10px 0', gap: '10px' }}>
              <div className="d-flex  flex-column" style={{ padding: '0px 0px 0px 0', gap: '10px', opacity: `${!item.isActive && '0.5'}` }}>
                <div style={{ display: 'flex', minWidth: '25%' }}>
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Jobsite"
                    value={item?.jobsite}
                    valueID={item?.unitID}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Lot/Unit#"
                    value={item?.unitName}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Builder Job Number"
                    value={item?.jobNumber}
                  />
                  <HeaderValueCell className="bgWhite flex-column-dateFields" heading="Address" value={item?.address} />
                  {item?.feeWaived && (
                    <Grid container spacing={0.5} className="bgWhite flex-column-dateFields">
                      <Grid item lg={12} sm={12} xl={12} xs={12} style={{ paddingTop: 12 }}>
                        <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                          Fee Waived
                          <img
                            src={Icons.IconWarning}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setIsOpenFeeWave(true);
                            }}
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </div>
              </div>
              <div className="d-flex  flex-column" style={{ padding: '0px 0px 0px 0', gap: '10px', opacity: `${!item.isActive && '0.5'}` }}>
                <div style={{ display: 'flex', minWidth: '25%' }}>
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Customer"
                    value={item?.customerName}
                  />

                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Office"
                    value={item?.officeName}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Project"
                    value={item?.projectName}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Project Code"
                    value={item?.projectCode}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Billing Type"
                    value={item?.billingType}
                  />
                </div>
              </div>
              <div className="d-flex  flex-column" style={{ padding: '0px 0px 0px 0', gap: '10px', opacity: `${!item.isActive && '0.5'}` }}>
                <div style={{ display: 'flex', minWidth: '25%' }}>
                  {/* <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Billing Against"
                    value={item?.billingAgainst}
                  /> */}
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Invoice Amount ($)"
                    value={item?.invoiceAmount}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Accrual Amount ($)"
                    value={item?.accrualAmount}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Invoice #"
                    value={item?.invoiceNo}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Invoice Date"
                    value={item?.invoiceDate}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Invoice Due Date"
                    value={item?.invoiceDueDate}
                  />
                  <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Payment Status"
                    value={item?.paymentStatus}
                  />
                  {/* <HeaderValueCell
                    className="bgWhite flex-column-dateFields"
                    heading="Balance Amount ($)"
                    value={item?.balanceAmount}
                  /> */}
                </div>
              </div>

              <div className="d-flex flex-column" style={{ flex: '1' }}>
                <div className="d-flex flex-row" style={{ flex: '1' }}>
                  <div className="d-flex" style={{ display: 'flex', flex: '3' }}>
                    {item.isHourlyorTimeMaterialService && (
                      <HeaderValueCell
                        className="bgWhite flex-column-dateFields"
                        heading="Invoice Term"
                        value={item?.invoiceTermText}
                      />
                    )}
                    {item.isHourlyorTimeMaterialService &&
                      item?.isScheduled &&
                      item?.workOrderStatus !== 'Cancelled' && (
                        //  <HeaderValueCell className=" bgWhite" heading="Worked Hours " value={item.workedHours} /> */}
                        <>
                          <Grid container spacing={0.5} className="bgWhite">
                            <Grid item lg={12} sm={12} xl={12} xs={12}>
                              <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                                Worked Hours
                                <Tooltip title={<Typography variant="body1">Edit Worked Hours</Typography>}>
                                  <IconButton
                                    disabled={!!item?.isUnitCompleted}
                                    aria-label="reload"
                                    onClick={() => setIsOpenEmployeeGrid(true)}
                                    sx={{
                                      color: (theme) => theme.palette.primary.light,
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                              </Typography>
                              {/* {!isEditEorkedHours && (
                                <Typography variant="body1" className="custDesign">
                                  {item.workedHours ? item.workedHours : '-'}
                                </Typography>
                              )} */}
                              {/* 
                              {isEditEorkedHours && (
                                <div className="workedHrsBlock">
                                  <TextField
                                    id="reason"
                                    label=""
                                    variant="outlined"
                                    value={workedHoursValue}
                                    onChange={(e: any) => handleWorkedHoursValueChange(e)}
                                    error={reasonError}
                                    helperText={reasonError ? 'Worked Hours is required' : ''}
                                    margin="normal"
                                  />
                                  <div className="workedHrsActionBlock">
                                    <button
                                      className="btn btn-sm btn-default btn-primary"
                                      type="button"
                                      onClick={handleSaveClick}
                                      disabled={isLoading || !!isCompleted}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <SaveIcon />
                                    </button>
                                    <button
                                      style={{ cursor: 'pointer' }}
                                      className="btn btn-sm btn-default btn-lightGrey"
                                      onClick={() => setIsEditWorkedHours(false)}
                                      autoFocus
                                    >
                                      <HighlightOffIcon />
                                    </button>
                                  </div>
                                </div>
                              )} */}
                            </Grid>
                          </Grid>
                        </>
                      )}
                    {item?.bundleService && (
                      <>
                        <HeaderValueCell
                          className="bgWhite flex-column-dateFields"
                          heading="Bundle Name"
                          value={item?.bundleName}
                        />
                        <HeaderValueCell
                          className="bgWhite flex-column-dateFields"
                          heading="Bundle Price ($)"
                          value={item?.bundlePrice}
                        />
                        <HeaderValueCell
                          className="bgWhite flex-column-dateFields"
                          heading="Split Name"
                          value={item?.splitName}
                        />
                        <HeaderValueCell
                          className="bgWhite flex-column-dateFields"
                          heading="Split Amount ($)"
                          value={item?.splitAmt}
                        />
                      </>
                    )}
                    {/* <HeaderValueCell
                      className="bgWhite flex-column-dateFields"
                      heading="Invoice Type"
                      value={item?.Invoice}
                    /> */}
                  </div>
                  {/* <div style={{ display: 'flex', flex: '1', minWidth: '115px', marginLeft: '10px' }}>
                    <HeaderValueCell
                      className="bgWhite flex-column-dateFields"
                      heading="Payment Status"
                      value={item?.Payment}
                    />
                  </div> */}
                  {/* 
                  <div style={{ display: 'flex', flex: '1', minWidth: '115px', marginLeft: '10px' }}>
                    <HeaderValueCell className=" bgWhite" heading="Worked Hours " value={item.workedHours} />
                  </div>
                  )}                   */}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: '1',
                  justifyContent: 'space-between',
                  marginTop: '5px',
                }}
              >
                <GuardedComponent requiredPermissions={[UserPermissionName.UPDATE_STATUS_WORKORDER]}>
                  <div style={{ display: 'flex', marginRight: '15px', alignItems: 'center', flex: '0 0 auto' }}>
                    {!item.isUnitCompleted ? (
                      <WorkOrderStatusButtons workOrder={item} reloadData={reloadData} />
                    ) : (
                      <span style={{ color: 'red' }}>Lot/Unit is completed</span>
                    )}
                  </div>
                  <div style={{ display: 'flex', marginRight: 'auto', alignItems: 'center', flex: '0 0 auto' }}>
                    {!item.isActive && (
                      <span style={{ marginRight: 10, color: 'red' }}>Inactive</span>
                    )}
                  </div>
                </GuardedComponent>
                <div style={{ display: 'flex' }}>
                  {item?.showResultPdfButton && (
                    <>
                      <Button
                        size="small"
                        style={{ marginRight: 5, color: 'aliceblue' }}
                        variant="contained"
                        disabled={!!isCompleted}
                        onClick={() => setOpenFileDialog(true)}
                      // onClick={() => navigate(`/workorders/edit/${item?.workOrderID}`)}
                      >
                        View / Download
                      </Button>
                    </>
                  )}
                  {isOpenEmployeeGrid && (
                    <WorkOrderEmployee
                      workOrderId={item?.workOrderID}
                      handleCloseEmployeeGrid={handleCloseEmployeeGrid}
                      isOpen={isOpenEmployeeGrid}
                    />
                  )}
                  {item?.showScheduleDuxCall && (
                    <Tooltip title={<Typography variant="body1">
                      {item?.scheduledDuxCallContact
                        ? `Dux call scheduled for ${item.scheduledDuxCallContact}.`
                        : 'Dux call not scheduled for any contact.'}
                    </Typography>}>
                      <Button
                        size="small"
                        style={{ marginRight: 5, color: 'aliceblue' }}
                        variant="contained"
                        onClick={() => setOpenScheduleDuxDialog({ workOrderID: item?.workOrderID, customerID: item?.customerID })}
                      >
                        SCHEDULE DUX CALL
                      </Button>
                    </Tooltip>
                  )}
                  <Button
                    size="small"
                    style={{ marginRight: 5, color: 'aliceblue' }}
                    variant="contained"
                    onClick={handlePopoverOpen}
                  >
                    MORE INFO
                  </Button>
                  <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_WORKORDER]}>
                    <Button
                      disabled={!!item?.isUnitCompleted}
                      className={`btn  btnEditConpressed ${!isCompleted && 'btn-primary'}`}
                      onClick={() => navigate(`/workorders/edit/${item?.workOrderID}`)}
                    >
                      <Tooltip title={<Typography variant="body1">Edit</Typography>}>
                        <EditIcon className="btnEdit" />
                      </Tooltip>
                    </Button>
                  </GuardedComponent>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      {openScheduleDuxDialog && (
        <ScheduleDuxCallDialog
          open={openScheduleDuxDialog}
          onDuxCall={handleSendDuxCallSuccess}
          onClosed={handleClosedScheduleCallDialog} />
      )}
      {openPurchaseOrder && (
        <PurchaseOrderDialog
          title="PURCHASE ORDER"
          workOrderData={item}
          workOrderID={item.workOrderID}
          open={openPurchaseOrder}
          onClose={handleClosePurchaseOrderDialog}
          reloadData={reloadData}
        />
      )}
      {openNoteDialog && (
        <NotesDialog
          title="WORK ORDER"
          noteRequestArgs={{ workOrderID: item.workOrderID }}
          open={openNoteDialog}
          onClose={handleCloseNotesDialog}
        />
      )}
      {openFileDialog && (
        <FileDownloadDialog workOrderID={item.workOrderID} onClosed={() => setOpenFileDialog(false)} />
      )}
      <ReactHookForm formName="WORKORDER_FORM" onSubmit={handleSubmit} formContextProps={form} isBusy={isLoading}>
        {isContactVisible && (
          <ContactsDialogWithGridSelect
            open={isContactVisible}
            onClose={handleCloseAddContactForm}
            contacts={[]}
            customerID={item?.customerID}
            setValue={setValueForTab}
            value={valueForTab}
            editItem={editItem}
            setEditItem={setEditItem}
            watchKeys={['office.officeID']}
            getQueryKeyConfig={() => contactApiKeyStore.getUnitContacts(item?.unitID)}
            page="workOrderList"
            itemId={item?.unitID}
          />
          // <ContactsListDialog unitID={item?.unitID} open={isContactVisible} onClose={() => setIsContactVisible(false)} />
        )}
      </ReactHookForm>
      {isOpenFeeWave && (
        <Dialog open={isOpenFeeWave} className="modalpopup" title={'Alert'}>
          <IconButton
            aria-label="close"
            onClick={() => setIsOpenFeeWave(false)}
            sx={{
              position: 'absolute',
              right: 10,
              top: 15,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          <div>
            <div style={{ padding: '15px 20px' }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                    Fee Waived On
                  </Typography>
                  <Typography variant="body1" className="custDesign" style={{ marginBottom: '6px' }}>
                    {item?.feeWaivedOn}
                  </Typography>
                </Grid>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                    Fee Waived By
                  </Typography>
                  <Typography variant="body1" className="custDesign" style={{ marginBottom: '6px' }}>
                    {item?.feeWaivedBy}
                  </Typography>
                </Grid>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                    Fee Waived Reason
                  </Typography>
                  <Typography variant="body1" className="custDesign" style={{ marginBottom: '6px' }}>
                    {item?.feeWaivedReason}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
          {/* <DialogActionsBar>
            <div className="spaceBetween">
              <div></div>
              <button
                className="btn btn-sm btn-primary btn-delete"
                type="button"
                onClick={() => setIsOpenFeeWave(false)}
                style={{ cursor: 'pointer' }}
              >
                Cancel
              </button>
            </div>
          </DialogActionsBar> */}
        </Dialog>
      )}

      <Popover
        className="popOverOuterWrap"
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <div className="popOverInnererWrap">
          <Typography variant="body1" className="d-flex">
            <small>Skill Sets: </small> {item?.serviceSkillsets || ''}
          </Typography>
          <Typography variant="body1" className="d-flex">
            <small>Equipments: </small> {item?.serviceEquipments || ''}
          </Typography>
        </div>
      </Popover>

      <LoadingIndicator isLoading={isLoadingWorkOrder} />
    </>
  );
};
